// extracted by mini-css-extract-plugin
export default {"container":"Tab_container__w+Fpv","container--active":"Tab_container--active__07vfU"};